const BASE_PORT = 3000
// let BASE_URL = `https://consultoria.sinkr.com.br:${BASE_PORT}`
let BASE_URL = `https://ac2.sinkr.com.br:${BASE_PORT}`

if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
  BASE_URL = `http://localhost:${BASE_PORT}`
  // BASE_URL = `https://consultoria.sinkr.com.br:${BASE_PORT}`
}

module.exports = {
  BASE_PORT,
  BASE_URL
}



// WEBPACK FOOTER //
// ./src/communication/ConnectionConfig.js